import JoditEditor from 'jodit-react';
import { useEffect, useRef, useState } from 'react';
import { Container } from './styles';
import api from '../../services/api';

interface EditorProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  tabIndex?: number;
}

const WysiwygJodit: React.FC<EditorProps> = ({
  name,
  value,
  onChange,
  tabIndex,
}) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState(value);

  useEffect(() => {
    onChange(content);
  }, [content, onChange]);

  return (
    <Container hasError={false} style={{ marginBottom: '24px' }}>
      <JoditEditor
        ref={editorRef}
        name={name}
        key={name}
        value={content}
        tabIndex={tabIndex}
        onBlur={newContent => setContent(newContent)}
        config={{
          askBeforePasteHTML: false,
          askBeforePasteFromWord: false,
          defaultActionOnPaste: 'insert_as_text',
          readonly: false,
          placeholder: '',
          showPlaceholder: false,
          showCharsCounter: false,
          showWordsCounter: false,
          showXPathInStatusbar: false,
          disablePlugins: 'add-new-line',
          events: {
            beforePaste: async (event: ClipboardEvent) => {
              event.preventDefault();

              const items = event.clipboardData?.items;
              if (!items) return;

              // @ts-ignore
              for (let item of items) {
                if (item.kind === 'file') {
                  const file = item.getAsFile();
                  if (file) {
                    const formData = new FormData();
                    formData.append('file', file);
                    const response = await api.patch(
                      '/exercises/upload',
                      formData,
                    );
                    document.execCommand('insertImage', false, response.data);
                  }
                  event.preventDefault();
                }
              }
            },
          },
          buttons: [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'superscript',
            'subscript',
            '|',
            'ul',
            'ol',
            '|',
            'table',
            'link',
            'video',
            'image',
            '|',
            'left',
            'center',
            'right',
            'justify',
            '|',
            'undo',
            'redo',
            'preview',
          ],
        }}
      />
    </Container>
  );
};

export default WysiwygJodit;
